import React from "react"

import type { JsonLdGraph, JsonLdNode } from "../utils/jsonLd"

export interface JsonLdScriptProps {
  /** 单个节点或由 buildJsonLdGraph 组装的 @graph 文档 */
  data: JsonLdGraph | JsonLdNode
}

/**
 * 将 JSON-LD 安全序列化为 <script type="application/ld+json">。
 * 把 "<" 转义为 <，防止内容中的 "</script>" 提前闭合标签造成 XSS。
 */
function serializeJsonLd(data: JsonLdGraph | JsonLdNode): string {
  return JSON.stringify(data).replace(/</g, "\\u003c")
}

/**
 * JSON-LD 注入组件（Server Component）。
 * 可放在任意 server 页面/布局中渲染，Next.js 会把脚本随 HTML 输出；
 * 全局节点（Organization / WebSite）放根布局，页面节点放各自 page。
 */
export function JsonLdScript({ data }: JsonLdScriptProps) {
  // 内容已经过 < 转义，安全
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: serializeJsonLd(data) }} />
}
